import { render, staticRenderFns } from "./basic-form.vue?vue&type=template&id=8b427ba0"
import script from "./basic-form.vue?vue&type=script&lang=js"
export * from "./basic-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports